var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classes,attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('span',{class:_vm.icons}):_vm._e(),_vm._t("default"),_vm._t("footer",null,{"data":_vm.text})],2)}
var staticRenderFns = []

export { render, staticRenderFns }